<template>
    <b-modal :title="this.$route.name" hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="updateApplication">
            <div  class="form-group row">
                <label  class="col-sm-3 col-form-label">কার্যক্রম শুরুর তারিখ</label>
                <div class="col-sm-3">
                    <input name="approve_date" v-validate="'required'" type="date" v-model="editApplicationForm.approve_date" class="form-control">
                    <p v-show="errors.has('approve_date')"  style="color:red">* {{ errors.first('approve_date') }}</p>
                </div>
                <label class="col-sm-3 col-form-label">স্ট্যাটাস</label>
                <div class="col-sm-3">
                    <select class="form-control formInput" v-validate="'required'" v-model="editApplicationForm.status" name="status">
                        <option v-for="status in statusList" :selected="editApplicationForm.status === status.val" :value="status.val" :key="status.val">{{ status.name }}</option>
                    </select>
                    <p v-show="errors.has('status')"  style="color:red">* {{ errors.first('status') }}</p>
                </div>
            </div>
            <hr>
            <div class="form-group row">
                <div class="col-sm-12">
                    <input type="submit" value="submit" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                    <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    import axios from 'axios'
    import { UPDATE_MARKET_APPLICATION} from "@/store/action.type"
    export default {
        name: "editApplicationModal",
        data(){
            return{
                largeModal:false,
                addLoader: false,
                addApplicationLoader:false,
                index:null,
                editApplicationForm:{
                    id:'',
                    approve_date:'',
                    status:''
                },
                statusList: [
                    { name: "অচল/পেন্ডিং", val: 0 },
                    { name: "সচল", val: 1 },
                    { name: "বাতিলকৃত", val: 2 },
                ],
            }
        },

        computed:{
            ...mapGetters(['modal','wards'])
        },
        methods:{
            openModal(application,index){
                this.largeModal = true
                this.index = index
                this.editApplicationForm.id = application.id
                this.editApplicationForm.approve_date = application.approve_date
                this.editApplicationForm.status = application.status
                console.log(this.editApplicationForm.id)
            },
            close(){
                this.largeModal = false
            },
            updateApplication(){
                this.$validator.validateAll().then( result =>{
                    if(result){
                        var data = this.editApplicationForm
                        var index = this.index
                        this.addApplicationLoader = true;
                        this.$store.dispatch('UPDATE_CLOSE_MARKET_APPLICATION',{data,index})
                        .then(response=>{
                            this.addApplicationLoader = false;
                            this.largeModal = false
                        })
                        .catch(error=>{
                            this.addApplicationLoader=false;
                            this.servererrors = error.response.data.errors;
                        });
                    }

                })
            }
        }
    }

</script>

<style scoped>

</style>